import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

// Define the base endpoint for dashboard
const DASHBOARD_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.DASHBOARD,
  false // No tenant ID in the base URL
);

export const getFarmerCard = ({ start_date, end_date }) =>
  client.post(`${DASHBOARD_BASE}/farmer/card`, {
    start_date: start_date,
    end_date: end_date
  });

export const getSmsCard = ({ start_date, end_date }) =>
  client.post(`${DASHBOARD_BASE}/sms/card`, {
    start_date: start_date,
    end_date: end_date
  });

export const getFarmerChart = ({ start_date, end_date, limit }) =>
  client.post(`${DASHBOARD_BASE}/farmer/chart`, {
    start_date: start_date,
    end_date: end_date,
    limit
  });

export const getGenderChart = ({ start_date, end_date, limit }) =>
  client.post(`${DASHBOARD_BASE}/gender/chart`, {
    start_date: start_date,
    end_date: end_date,
    limit
  });

export const getSmsGroupChart = ({ start_date, end_date, limit }) =>
  client.post(`${DASHBOARD_BASE}/smsgroup/chart`, {
    start_date: start_date,
    end_date: end_date,
    limit
  });

export const getMarketPriceDashboardCharts = ({
  start_date,
  end_date,
  limit
}) =>
  client.post(`${DASHBOARD_BASE}/marketprice/charts`, {
    start_date: start_date,
    end_date: end_date,
    limit
  });
